import { defineMessage } from 'services/localization';

export const messages = {
    defaultStepName: defineMessage('approval_step'),
    defaultWorkflowName: defineMessage('new_workflow'),
};
